import { render, staticRenderFns } from "./DeviceAlertDeleteDialog.vue?vue&type=template&id=7b70fa96&scoped=true"
import script from "./DeviceAlertDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./DeviceAlertDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeviceAlertDeleteDialog.vue?vue&type=style&index=0&id=7b70fa96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b70fa96",
  null
  
)

export default component.exports